<template>
  <div ref="seccionHospedajeRef" class="seccion-hospedaje-container">
    
    <!-- 🦋 MARIPOSAS FLOTANTES DECORATIVAS -->
    <div class="mariposas-layer">
      <img src="@/assets/mariposa.png" class="mariposa-img m-1" alt="Mariposa" />
      <img src="@/assets/mariposa.png" class="mariposa-img m-2" alt="Mariposa" />
      <img src="@/assets/mariposa.png" class="mariposa-img m-3" alt="Mariposa" />
    </div>

    <div class="overlay-hospedaje">
      
      <!-- 🎀 DECORACIÓN SUPERIOR: MOÑO ROJO 
      <div ref="monioRef" class="monio-full-width-wrapper">
        <img src="@/assets/monio.png" alt="Moño Rojo" class="monio-header-img" />
      </div>-->

      <!-- 🎭 MÁSCARA DORADA -->
      <div ref="mascaraRef" class="mascara-wrapper">
        <img src="@/assets/mascarr.png" alt="Máscara Antifaz" class="mascara-img" />
      </div>

      <!-- 🏨 ENCABEZADO DE HOSPEDAJE -->
      <div ref="headerRef" class="encabezado-container">
      
        <h2 class="mis-xv-title">Sugerencias de <span class="h-great">H</span>ospedaje</h2>

        <p class="bendicion-linea">ELK GROVE, CALIFORNIA</p>
      </div>

      <!-- 💳 TARJETA INTERACTIVA DE HOSPEDAJE (SLIDER) -->
      <div ref="cardRef" class="hospedaje-card-slider">
        <button class="slider-btn prev" @click="prevHotel" aria-label="Anterior">❮</button>
        
        <div class="hotel-card-active">
          <span class="hotel-badge">Opción {{ activeHotelIndex + 1 }} de {{ hoteles.length }}</span>
          <h4 class="hotel-nombre">{{ hoteles[activeHotelIndex].nombre }}</h4>
          
          <!-- 🌸 SEPARADOR FLORAL -->
          <img src="@/assets/separador.png" alt="Separador floral" class="separador-flores" />
          
          <p class="hotel-direccion">📍 {{ hoteles[activeHotelIndex].direccion }}</p>
          <a :href="'tel:' + hoteles[activeHotelIndex].telefonoLimpio" class="hotel-telefono">
            📞 {{ hoteles[activeHotelIndex].telefono }}
          </a>
          
          <a
            :href="hoteles[activeHotelIndex].mapsUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="btn-llegar"
          >
            Cómo llegar
          </a>
        </div>

        <button class="slider-btn next" @click="nextHotel" aria-label="Siguiente">❯</button>
      </div>

      <!-- BOTÓN VER TODOS -->
      <div ref="btnRef" class="btn-container">
        <button class="btn-ver-todos" @click="isModalHotelesOpen = true">
          Ver todas las opciones de hospedaje
        </button>
      </div>

    </div>

    <!-- 🏨 MODAL COMPLETO DE HOTELES -->
    <div
      v-if="isModalHotelesOpen"
      class="modal-overlay"
      @click.self="isModalHotelesOpen = false"
    >
      <div class="modal-card">
        <button class="btn-close-modal" @click="isModalHotelesOpen = false">✕</button>
        <h3 class="modal-titulo">Hospedaje Recomendado</h3>
        <p class="modal-subtitulo">Elk Grove, CA</p>

        <div class="hoteles-lista">
          <div
            v-for="(hotel, index) in hoteles"
            :key="index"
            class="hotel-item-modal"
          >
            <div class="hotel-info">
              <h4 class="hotel-nombre-modal">{{ hotel.nombre }}</h4>
              <p class="hotel-direccion-modal">📍 {{ hotel.direccion }}</p>
              <a :href="'tel:' + hotel.telefonoLimpio" class="hotel-tel-modal">📞 {{ hotel.telefono }}</a>
            </div>
            <a
              :href="hotel.mapsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-llegar-modal"
            >
              Llegar
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionHospedajeElegante',
  setup() {
    const seccionHospedajeRef = ref(null)
    const monioRef = ref(null)
    const mascaraRef = ref(null)
    const headerRef = ref(null)
    const cardRef = ref(null)
    const btnRef = ref(null)

    const isModalHotelesOpen = ref(false)
    const activeHotelIndex = ref(0)

    const hoteles = [
      {
        nombre: 'Hampton Inn & Suites',
        direccion: '2305 Longport Ct, Elk Grove, CA 95758',
        telefono: '(916) 683-9545',
        telefonoLimpio: '9166839545',
        mapsUrl: 'https://maps.google.com/?q=Hampton+Inn+%26+Suites+2305+Longport+Ct+Elk+Grove+CA+95758'
      },
      {
        nombre: 'Holiday Inn Express & Suites',
        direccion: '2460 Maritime Dr, Elk Grove, CA 95758',
        telefono: '(916) 478-4000',
        telefonoLimpio: '9164784000',
        mapsUrl: 'https://maps.google.com/?q=Holiday+Inn+Express+%26+Suites+2460+Maritime+Dr+Elk+Grove+CA+95758'
      },
      {
        nombre: 'TownePlace Suites by Marriott',
        direccion: '9320 E Stockton Blvd, Elk Grove, CA 95624',
        telefono: '(916) 892-1000',
        telefonoLimpio: '9168921000',
        mapsUrl: 'https://maps.google.com/?q=TownePlace+Suites+by+Marriott+9320+E+Stockton+Blvd+Elk+Grove+CA+95624'
      }
    ]

    const nextHotel = () => {
      activeHotelIndex.value = (activeHotelIndex.value + 1) % hoteles.length
    }

    const prevHotel = () => {
      activeHotelIndex.value = (activeHotelIndex.value - 1 + hoteles.length) % hoteles.length
    }

    onMounted(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionHospedajeRef.value,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      })

      tl.from(monioRef.value, {
        opacity: 0,
        y: -35,
        scale: 0.95,
        duration: 1.1,
        ease: 'power2.out'
      })
      .from(mascaraRef.value, {
        opacity: 0,
        y: -20,
        scale: 0.8,
        duration: 0.8,
        ease: 'back.out(1.5)'
      }, '-=0.4')
      .from(headerRef.value, {
        opacity: 0,
        y: 25,
        duration: 0.9,
        ease: 'power3.out'
      }, '-=0.3')
      .from(cardRef.value, {
        opacity: 0,
        scale: 0.92,
        y: 25,
        duration: 0.9,
        ease: 'back.out(1.4)'
      }, '-=0.4')
      .from(btnRef.value, {
        opacity: 0,
        y: 15,
        duration: 0.7,
        ease: 'power2.out'
      }, '-=0.3')
    })

    return {
      seccionHospedajeRef,
      monioRef,
      mascaraRef,
      headerRef,
      cardRef,
      btnRef,
      hoteles,
      activeHotelIndex,
      isModalHotelesOpen,
      nextHotel,
      prevHotel
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. CONTENEDOR Y ESTÉTICA GENERAL
   ========================================== */
.seccion-hospedaje-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  padding-bottom: 60px;
}

.overlay-hospedaje {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

/* ==========================================
   2. ELEMENTOS DECORATIVOS (MOÑO Y MÁSCARA)
   ========================================== */
.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.monio-header-img {
  width: 100%;
  min-width: 100%;
  max-width: none;
  height: auto;
  display: block;
  object-fit: cover;
}

.mascara-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 45px;
  margin-bottom: 20px;
  z-index: 4;
}

.mascara-img {
  width: 160px;
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
}

/* ==========================================
   3. TIPOGRAFÍAS Y TEXTOS
   ========================================== */
.encabezado-container {
  text-align: center;
  margin: 0 auto 25px;
  padding: 0 24px;
  max-width: 550px;
  box-sizing: border-box;
}

.poema-linea {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  line-height: 1.6;
  color: #6E5336;
  font-style: italic;
  margin-bottom: 12px;
}

.mis-xv-title {
  font-family: "Great Vibes", cursive;
  font-size: 48px;
  color: #8C1C29;
  font-weight: 500;
  margin: 10px 0;
  line-height: 1.5;
}

.bendicion-linea {
  font-family: 'Playfair Display', serif;
  font-size: 13px;
  line-height: 1.5;
  color: #B08D57;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

/* ==========================================
   4. TARJETA SLIDER INTERACTIVA
   ========================================== */
.hospedaje-card-slider {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 90%;
  max-width: 460px;
  margin-bottom: 25px;
}

.hotel-card-active {
  background: #ffffff;
  border-radius: 18px;
  padding: 22px 18px;
  flex: 1;
  box-shadow: 0 10px 25px rgba(140, 28, 41, 0.08);
  border: 1px solid rgba(176, 141, 87, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.hotel-badge {
  font-family: 'Playfair Display', serif;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #B08D57;
  font-weight: 600;
  margin-bottom: 8px;
}

.hotel-nombre {
  font-family: 'Playfair Display', cursive;
  font-size: 24px;
  color: #B08D57;
  margin: 0 0 6px;
  line-height: 1.1;
}

/* ESTILO DEL SEPARADOR FLORAL */
.separador-flores {
  width: 120px;
  height: auto;
  margin: 4px 0 12px 0;
  object-fit: contain;
}

.hotel-direccion {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  color: #6E5336;
  margin: 0 0 6px;
  line-height: 1.4;
}

.hotel-telefono {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  color: #8C1C29;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 16px;
}

.btn-llegar {
  display: inline-block;
  padding: 10px 22px;
  background: #8C1C29;
  color: #ffffff;
  text-decoration: none;
  border-radius: 25px;
  font-family: 'Playfair Display', serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-shadow: 0 4px 12px rgba(140, 28, 41, 0.2);
  transition: all 0.3s ease;
}

.btn-llegar:hover {
  background: #6e1520;
}

.slider-btn {
  background: #ffffff;
  border: 1px solid rgba(176, 141, 87, 0.4);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  color: #8C1C29;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  transition: all 0.2s;
}

.slider-btn:hover {
  background: #fdfbf7;
  border-color: #8C1C29;
}

/* ==========================================
   5. BOTÓN PRINCIPAL "VER TODOS"
   ========================================== */
.btn-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn-ver-todos {
  background: transparent;
  border: 1.5px solid #B08D57;
  color: #8C1C29;
  font-family: 'Playfair Display', serif;
  padding: 12px 28px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-ver-todos:hover {
  background: #8C1C29;
  border-color: #8C1C29;
  color: #ffffff;
}

/* ==========================================
   6. MODAL COMPLETO
   ========================================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 30px 22px;
  width: 100%;
  max-width: 480px;
  position: relative;
  box-shadow: 0 15px 35px rgba(0,0,0,0.2);
  max-height: 85vh;
  overflow-y: auto;
  border: 1px solid #B08D57;
}

.btn-close-modal {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 18px;
  color: #8C1C29;
  cursor: pointer;
}
.h-great {
  font-family: "Great Vibes", cursive;
}
.modal-titulo {
  font-family:'Playfair Display', cursive;
  font-size: 38px;
  color: #8C1C29;
  margin: 0 0 2px;
  text-align: center;
}

.modal-subtitulo {
  font-family: 'Playfair Display', serif;
  font-size: 12px;
  color: #B08D57;
  text-align: center;
  margin-bottom: 22px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 600;
}

.hoteles-lista {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.hotel-item-modal {
  background: #fdfbf7;
  border-radius: 14px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border-left: 4px solid #8C1C29;
}

.hotel-info {
  text-align: left;
}

.hotel-nombre-modal {
  font-family: 'Playfair Display', cursive;
  font-size: 28px;
  color: #B08D57;
  margin: 0 0 4px;
  line-height: 1;
}

.hotel-direccion-modal {
  font-family: 'Playfair Display', serif;
  font-size: 12px;
  color: #6E5336;
  margin: 0 0 4px;
}

.hotel-tel-modal {
  font-family: 'Playfair Display', serif;
  font-size: 12px;
  color: #8C1C29;
  text-decoration: none;
  font-weight: 600;
}

.btn-llegar-modal {
  background: #8C1C29;
  color: #ffffff;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* ==========================================
   7. MARIPOSAS DE FONDO
   ========================================== */
.mariposas-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.mariposa-img {
  position: absolute;
  height: auto;
  opacity: 0.9;
  animation: aleteoSutil 1.8s infinite ease-in-out alternate;
}

.m-1 { top: 15%; left: 6%; width: 38px; transform: rotate(-12deg); }
.m-2 { top: 48%; right: 6%; width: 42px; transform: rotate(15deg); }
.m-3 { top: 82%; left: 8%; width: 36px; transform: rotate(-8deg); }

@keyframes aleteoSutil {
  0% { transform: scaleX(1); }
  100% { transform: scaleX(0.65); }
}
</style>